module.exports = __webpack_public_path__ + "static/img/NO.d6fb6a36.svg";